import { createAction, props } from '@ngrx/store';
import { IFundSource, IFundSources } from "@classifieds-sell/datalayer";

export const getFundSources = createAction('[Ping/API] Get Fund Sources');

export const getFundSourcesSuccess = createAction(
    '[Ping/API] Get Fund Sources Success',
    props<{ fundSources: IFundSources }>()
);

export const getFundSourcesFailure = createAction(
    '[Ping/API] Get Fund Sources Failure',
    props<{ error: any }>()
);

export const deleteFundSources = createAction(
    '[Ping/API] Delete Fund Sources',
    props<{ fundSource: IFundSource }>()
);

export const deleteFundSourcesSuccess = createAction(
    '[Ping/API] Delete Fund Sources Success',
    props<{ fundSource: IFundSource }>()
);

export const deleteFundSourcesFailure = createAction(
    '[Ping/API] Delete Fund Sources Failure',
    props<{ error: any; fundSource: IFundSource }>()
);
